import { c as _c } from "react/compiler-runtime";
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import ErrorComponent from '../../../components/error';
import FadeInContainer from '../../../components/fade-in-container';
import IdDocPhotoButtons from '../../../components/id-doc-photo-buttons';
import type { IdDocImageErrorType, ReceivedImagePayload } from '../../../types';
type MobileRetryViewProps = {
  docName: string;
  errors: IdDocImageErrorType[];
  hasBadConnectivity: boolean | undefined;
  allowPdf: boolean;
  hideUploadButton: boolean;
  uploadFirst: boolean;
  onComplete: (payload: ReceivedImagePayload) => void;
  onTakePhoto: () => void;
  onBack: () => void;
};
const MobileRetryView = t0 => {
  const $ = _c(18);
  const {
    docName,
    errors,
    hasBadConnectivity,
    allowPdf,
    hideUploadButton,
    uploadFirst,
    onComplete,
    onTakePhoto,
    onBack
  } = t0;
  let t1;
  if ($[0] !== onBack) {
    t1 = <NavigationHeader leftButton={{
      variant: "back",
      onBack
    }} position="floating" />;
    $[0] = onBack;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== docName || $[3] !== errors) {
    t2 = <ErrorComponent docName={docName} errors={errors} />;
    $[2] = docName;
    $[3] = errors;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== allowPdf || $[6] !== hasBadConnectivity || $[7] !== hideUploadButton || $[8] !== onComplete || $[9] !== onTakePhoto || $[10] !== uploadFirst) {
    t3 = <IdDocPhotoButtons onComplete={onComplete} hideUploadButton={hideUploadButton} allowPdf={allowPdf} uploadFirst={uploadFirst} onTakePhoto={onTakePhoto} hasBadConnectivity={hasBadConnectivity} />;
    $[5] = allowPdf;
    $[6] = hasBadConnectivity;
    $[7] = hideUploadButton;
    $[8] = onComplete;
    $[9] = onTakePhoto;
    $[10] = uploadFirst;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className="h-full flex flex-col gap-6 items-center justify-center">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t4) {
    t5 = <FadeInContainer>{t1}{t4}</FadeInContainer>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default MobileRetryView;